export const _getFindingsParamsFromSearch = (
  search: URLSearchParams
): URLSearchParams => {
  // Remove params from search that are only relevant to frontend
  const filterQuery = new URLSearchParams(search);

  // The following params are only relevant for the frontend
  filterQuery.delete("policy_name");

  // The following params we may want to add back later (when we can filter by ref type)
  filterQuery.delete("ref_type");

  return filterQuery;
};
